module.exports = __webpack_public_path__ + "media/assets/images/circled-down-right-471753289d0e7a600c5cbb3c3171e35e.png";